import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { INVOICE_PAYMENT_METHOD } from "../../../../utils/constants";
import { InfoCircleOutlined } from "@ant-design/icons";
import "../InvoiceScreen.css";

const PaymentTable = ({ rows, paymentMethod, invoiceData }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltipOpen = () => {
    setTooltipOpen(true);
  };

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  return (
    <Box sx={{ overflowX: "auto" }}>
      <TableContainer component={Paper} className="invoices-data-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Invoice No.</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Payment Reference Number</TableCell>
              <TableCell>
                {paymentMethod === INVOICE_PAYMENT_METHOD.find(method => method.value === "WIRE_TRANSFER")?.value
                  ? "Paid Amount"
                  : "Grand Total"
                }
              </TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={row.invoiceNo}>
                <TableCell>{row.invoiceNo}</TableCell>
                <TableCell>{row.paymentMethod}</TableCell>
                <TableCell>{row.prn}</TableCell>
                <TableCell>{row.grandTotal}</TableCell>
                <TableCell
                  sx={{
                    color: row.Status === "Partial Paid"
                      ? "#000000 !important"
                      : row.Status === "Overpaid"
                        ? "#000000 !important"
                        : "#41D269 !important",
                    fontWeight: row.Status === "Paid" ? "700 !important" : "400 !important",
                    fontFamily: "Inter !important",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  {row.Status}
                  {row.Status === "Overpaid" && (
                    <Tooltip
                      open={tooltipOpen}
                      onOpen={handleTooltipOpen}
                      onClose={handleTooltipClose}
                      placement="bottom-start"
                      title={`There is credit balance of BSD ${Math.abs(parseFloat(invoiceData?.totalPaymentReceived || 0) - parseFloat(invoiceData?.invoiceAmount || 0)).toFixed(2)} amount`}
                      arrow
                    >
                      <InfoCircleOutlined 
                        style={{ cursor: "pointer", fontSize: "14px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setTooltipOpen(!tooltipOpen);
                        }}
                      />
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PaymentTable;
